export const styles = {
  content: 'bg-content1-200 p-[80px_50px_50px_50px] rounded-medium',
  backdrop: 'bg-content1-200 bg-opacity-50',
}
